import { ContactInfo } from '../common/ContactInfo';

export function RegionalCoordinator_MyAccount() {
  return <ContactInfo />;
}
